
export default function HeroImage(props) {
    const {headerImage, title} = props
  return (
    <div
    className="w-full h-80 bg-brown bg-cover bg-center"
    style={{ backgroundImage: `url(${headerImage})` }}
  >
    <div className="w-full h-full bg-black bg-opacity-30 flex items-center justify-center">
      <h1 className="text-cream font-anton text-3xl sm:text-5xl font-bold text-center px-4">
        {title}
      </h1>
    </div>
  </div>
  );
}
